<template>
  <v-hover
    v-slot="{ hover }"
    :key="equipmentPack.id"
  >
    <v-row
      no-gutters
      class="px-1 py-1 list--bordered"
    >
      <v-col cols="auto">
        <v-icon
          style="font-size: 10px"
          :color="equipmentPack.category.color"
          class="mr-2"
        >
          circle
        </v-icon>
      </v-col>
      <v-col
        class="grey--text text--darken-1 text-truncate"
        :class="{ 'font-italic': equipmentPack.custom }"
      >
        {{ equipmentPack.label || (equipmentPack.custom ? 'Custom Pack' : 'N/A') }}
      </v-col>
      <v-col
        cols="auto"
        :class="{ 'd-none': !hover }"
      >
        <v-chip
          x-small
          label
          dark
          :color="equipmentPack.category.color"
        >
          {{ equipmentPack.category.name }}
        </v-chip>
      </v-col>
      <v-col
        v-if="$can('view-sale-price', 'YachtEquipmentPack')"
        cols="auto"
        :class="{ 'd-none': hover }"
        class="text-no-wrap"
      >
        {{ equipmentPack.sale_price | currency(equipmentPack.currency) }}
      </v-col>
    </v-row>
  </v-hover>
</template>
<script>
export default {
  name: 'SmallPricingListEquipmentRow',
  props: {
    equipmentPack: {
      type: Object,
      required: true
    }
  }
}
</script>
